var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { GalleryActions } from '../../state/gallery.actions';
import { GalleryState } from '../../state/gallery.state';
import { Subject, Observable } from 'rxjs';
import { OrganizationsState } from 'src/app/organizations/state/organizations.state';
import { takeUntil, filter, debounceTime, tap } from 'rxjs/operators';
import { groupBy } from 'lodash';
import { FormBuilder } from '@angular/forms';
var GalleryFiltersStudioComponent = /** @class */ (function () {
    function GalleryFiltersStudioComponent(store, changeDetectorRef, formBuilder) {
        this.store = store;
        this.changeDetectorRef = changeDetectorRef;
        this.formBuilder = formBuilder;
        this.ngUnsubscribe = new Subject();
        this.groupedOptions = {};
    }
    Object.defineProperty(GalleryFiltersStudioComponent.prototype, "queryControl", {
        get: function () {
            return this.form.get('query');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GalleryFiltersStudioComponent.prototype, "categoryControl", {
        get: function () {
            return this.form.get('category');
        },
        enumerable: true,
        configurable: true
    });
    GalleryFiltersStudioComponent.prototype.ngOnInit = function () {
        this.initForm();
        this.initFormListeners();
        this.populateDropdown();
    };
    GalleryFiltersStudioComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    GalleryFiltersStudioComponent.prototype.initForm = function () {
        var category = this.store.selectSnapshot(GalleryState.getStudioCategoryId);
        var query = this.store.selectSnapshot(GalleryState.getStudioQuery);
        this.form = this.formBuilder.group({
            category: [category],
            query: [query]
        });
    };
    GalleryFiltersStudioComponent.prototype.initFormListeners = function () {
        var _this = this;
        this.form.valueChanges
            .pipe(tap(function () {
            _this.category = _this.store.selectSnapshot(GalleryState.getStudioOptions).find(function (option) { return option.id === _this.categoryControl.value; });
            _this.changeDetectorRef.markForCheck();
        }), debounceTime(300), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.store.dispatch(new GalleryActions.SearchStudio(_this.category, _this.queryControl.value));
        });
    };
    GalleryFiltersStudioComponent.prototype.populateDropdown = function () {
        var _this = this;
        // Populate dropdown with organization collections, if available
        var organization = this.store.selectSnapshot(OrganizationsState.getOrganization);
        this.store.dispatch(new GalleryActions.GetStudioOptions(organization ? organization.id : null));
        this.store.select(GalleryState.getStudioOptions)
            .pipe(filter(function (options) { return options.length > 0; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (options) {
            _this.updateOptions(options);
        });
    };
    GalleryFiltersStudioComponent.prototype.updateOptions = function (options) {
        this.groupedOptions = groupBy(options, function (option) {
            return option.type;
        });
        var category = this.store.selectSnapshot(GalleryState.getStudioCategoryId);
        this.category = options.find(function (option) { return option.id === category; });
        this.categoryControl.setValue(this.category.id);
        this.changeDetectorRef.markForCheck();
    };
    __decorate([
        Select(GalleryState.getStudioCategoryId),
        __metadata("design:type", Observable)
    ], GalleryFiltersStudioComponent.prototype, "categoryId$", void 0);
    __decorate([
        Select(GalleryState.getStudioQuery),
        __metadata("design:type", Observable)
    ], GalleryFiltersStudioComponent.prototype, "query$", void 0);
    return GalleryFiltersStudioComponent;
}());
export { GalleryFiltersStudioComponent };
